<cdk-virtual-scroll-viewport #scroller appendOnly itemSize="50" class="content">
  <div class="grid">
    <ng-container *cdkVirtualFor="let productItem of productItems; let i = index">
      <div class="col-12 md:col-6 lg:col-4 xl:col-3">
        <mat-card class="product-card">
          <mat-card-header>
            <div class="flex justify-content-between flex-nowrap w-full">
              <div class="left">
                <div class="product-name">{{ productItem.Name }}</div>
                <mat-card-subtitle>{{ productItem.CategoryId }}</mat-card-subtitle>
              </div>
              <div class="align-self-center">
                <button mat-icon-button [matMenuTriggerFor]="menuRef" (click)="$event.stopPropagation(); setSelectedProduct(productItem)">
                  <mat-icon color="primary">more_vert</mat-icon>
                </button>
              </div>
            </div>
          </mat-card-header>
          <img
            class="mt-2 product-image"
            mat-card-image
            [src]="productItem.ImageUrl"
            [alt]="productItem.Name"
            (click)="onEditProduct(productItem)"
          />

          <mat-card-content class="mt-2">
            <div class="product-price">₱&nbsp;{{ (productItem.PublishedPrice + productItem.Vat) | number : '1.2-2'}}</div>
            <div class="product-uom">{{ productItem.UnitText }} | {{ productItem.Quantity | number : '1.2-2'}}</div>
            <p class="product-description">{{ productItem.Description }}</p>
          </mat-card-content>
        </mat-card>

        <mat-menu #menuRef="matMenu">
            <button mat-menu-item class="menu-item" (click)="onViewProduct(productItem)">
                <mat-icon>visibility</mat-icon>
                <span class="pl-2">Select</span>
            </button>
            <button mat-menu-item class="menu-item-danger" (click)="removeProduct(productItem.Id)">
                <mat-icon>delete</mat-icon>
                <span class="pl-1">Remove</span>
            </button>
        </mat-menu>
      </div>
    </ng-container>
  </div>
</cdk-virtual-scroll-viewport>

